import { render, staticRenderFns } from "./VerifyDeleteCompany.vue?vue&type=template&id=dfccb772"
import script from "./VerifyDeleteCompany.vue?vue&type=script&lang=js"
export * from "./VerifyDeleteCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports